import React, { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";

import appLogo from "../../assets/images/logo/logo+orange.png";

/**
 * Magic-login consumer.
 *
 * The backend (Partner API `POST /accounts/login-link`) mints a Firebase custom
 * token and hands out a link `{dashboard}/magic-login?token=<customToken>`.
 * This page exchanges that token for a real session via
 * `signInWithCustomToken`, then reloads into the app so it bootstraps logged in.
 *
 * It lives in `publicRoutes` because the user is NOT yet authenticated when they
 * land here — without a matching public route the app falls through to the
 * "Loading.." catch-all and nothing happens (which is the bug this fixes).
 */
const MagicLogin = () => {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState(null);
  const ran = useRef(false);

  useEffect(() => {
    // Guard against React 18 StrictMode double-invoke.
    if (ran.current) return;
    ran.current = true;

    const token = searchParams.get("token");
    if (!token) {
      setError("This login link is missing its token.");
      return;
    }

    (async () => {
      try {
        await firebase.auth().signInWithCustomToken(token);
        // Full reload so the app re-bootstraps with the fresh session.
        window.location.replace("/");
      } catch (err) {
        console.error("magic-login failed", err);
        setError(
          "This login link is invalid or has expired. Please request a new one."
        );
      }
    })();
  }, [searchParams]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100vw",
        flexDirection: "column",
        gap: "1rem",
        textAlign: "center",
        padding: "1rem",
      }}
    >
      <img
        src={appLogo}
        alt="BaxRx"
        border="0"
        style={{ width: "50vw", maxWidth: "280px" }}
      />
      {error ? (
        <>
          <span style={{ color: "#dc3545", maxWidth: "420px" }}>{error}</span>
          <Link to="/login" className="btn btn-primary">
            Go to login
          </Link>
        </>
      ) : (
        <>
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Signing you in…</span>
          </div>
          <span>Signing you in…</span>
        </>
      )}
    </div>
  );
};

export default MagicLogin;
